import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi-paperclip" }, null, -1)

import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { TicketPackRmodel } from '@/app.context/workspace/tickets/_spec/Ticket.Im.Rmodel';
import { IFileStorage, IWorkspaceStorage } from '@/io/storages';
import sys from '@/sys';
import { ref } from 'vue';
import { downloadTicketFile_identificator } from '@/controllers/workspaces/tickets/_spec/ticket.controller'
import * as ticketProcessor from '@/ops/workspaces/ticket.processor'



export default /*#__PURE__*/_defineComponent({
  __name: 'TicketFiles',
  props: {
    model: {},
    ticket: {},
    files: {},
    storage: {}
  },
  setup(__props: any) {

const upload = ref<HTMLInputElement | null>(null)



const props = __props


//

async function onFileChanged($event: Event): Promise<void> {

    const target = $event.target as HTMLInputElement;

    if (target && target.files) {

        const files = [...target.files]

        const s = props.files

        const t = props.ticket

        const m = props.storage


        if (s != null && t != null && m != null) {

            ticketProcessor.addFiles(s, m, t, files)
        }
        else sys.warn("/workspaces/ticket - Can't process file - file storage is null")


        upload.value!.value = ''
    }

    return Promise.resolve()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("input", {
        type: "file",
        ref_key: "upload",
        ref: upload,
        multiple: "",
        onChange: onFileChanged
      }, null, 544)
    ]),
    (_ctx.model && _ctx.ticket && _ctx.files)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.files, (f) => {
            return (_openBlock(), _createElementBlock("div", {
              key: f.identificator,
              class: "clickable",
              onClick: _withModifiers(($event: any) => (_unref(downloadTicketFile_identificator)(_ctx.ticket, f.identificator, _ctx.files, f.filename)), ["stop"])
            }, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(f.filename), 1)
            ], 8, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})